export default __webpack_public_path__ + "static/media/ThaiSansNeue-Light.7808ab9c.ttf";